/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 * Font collections for text logo builder
 */

export interface FontOption {
  name: string;
  family: string;
}

export interface FontCategory {
  category: string;
  description?: string;
  fonts: FontOption[];
}

export const FONT_COLLECTIONS: FontCategory[] = [
  {
    category: 'TÊN RIÊNG, THIỆP, LỜI CHÚC, CHỮ KÝ',
    fonts: [
      { name: 'SVN-Signature', family: 'SVN-Signature' },
      { name: 'SVN-Honeymoon', family: 'SVN-Honeymoon' },
      { name: 'iCiel Pacifico', family: 'Pacifico' },
      { name: 'iCiel Crocante', family: 'Crocante' },
      { name: 'SVN-Sofia', family: 'SVN-Sofia' },
    ],
  },
  {
    category: 'SLOGAN, THƯƠNG HIỆU',
    description: 'Dùng cho: thương hiệu cao cấp, bao bì, in ấn',
    fonts: [
      { name: 'SVN-Gilroy', family: 'SVN-Gilroy' },
      { name: 'Be Vietnam Pro', family: 'Be Vietnam Pro' },
      { name: 'SVN-Poppins', family: 'SVN-Poppins' },
      { name: 'SVN-Montserrat', family: 'SVN-Montserrat' },
      { name: 'SVN-Helvetica Neue', family: 'Helvetica Neue' },
      { name: 'SVN-Playfair Display', family: 'Playfair Display' },
      { name: 'SVN-Butler', family: 'SVN-Butler' },
      { name: 'SVN-Bodoni', family: 'SVN-Bodoni' },
      { name: 'SVN-Cormorant', family: 'SVN-Cormorant' },
    ],
  },
  {
    category: 'LOGO, TIÊU ĐỀ',
    fonts: [
      { name: 'SVN-Bebas Neue', family: 'SVN-Bebas Neue' },
      { name: 'SVN-Oswald', family: 'SVN-Oswald' },
      { name: 'SVN-Anton', family: 'SVN-Anton' },
    ],
  },
];

// Flatten to get all fonts
export const ALL_FONTS: FontOption[] = FONT_COLLECTIONS.flatMap(cat => cat.fonts);

// Default font
export const DEFAULT_FONT = 'SVN-Montserrat';

// Preset colors for text logo
export interface PresetColor {
  name: string;
  hex: string;
}

export const PRESET_COLORS: PresetColor[] = [
  { name: 'Black', hex: '#000000' },
  { name: 'Gold', hex: '#D4AF37' },
  { name: 'Silver', hex: '#C0C0C0' },
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Red', hex: '#DC2626' },
  { name: 'Blue', hex: '#2563EB' },
  { name: 'Green', hex: '#16A34A' },
  { name: 'Purple', hex: '#9333EA' },
  { name: 'Orange', hex: '#EA580C' },
  { name: 'Pink', hex: '#EC4899' },
  { name: 'Cyan', hex: '#06B6D4' },
  { name: 'Gray', hex: '#6B7280' },
];

export const DEFAULT_COLOR = '#000000'; // Black
